import RowTRComponentSwitch from "views/device-configuration/alerts/components/RowTRComponentSwitch";

const FormMQConfigAlerts = ({item, _TC}) => {
    return (
        <>
            <RowTRComponentSwitch
                fieldName="dist"
                _TC={_TC}
                valueIn={item.values.dist}
                hasIn={item.has.dist}
                deactivated="0"
                inputProps={{
                    min: "0",
                    max: "450",
                    step: "1",
                    "data-default": "30",
                }}
            />
            <RowTRComponentSwitch
                fieldName="sacc"
                _TC={_TC}
                valueIn={item.values.sacc}
                hasIn={item.has.sacc}
                deactivated="0"
                inputProps={{
                    min: "0",
                    max: "2",
                    step: "0.1",
                    "data-default": "1",
                }}
            />
            <RowTRComponentSwitch
                fieldName="temp"
                _TC={_TC}
                valueIn={item.values.temp}
                hasIn={item.has.temp}
                deactivated="0"
                inputProps={{
                    min: "0",
                    max: "254",
                    step: "1",
                    "data-default": "70",
                }}
            />
            <RowTRComponentSwitch
                fieldName="bat"
                _TC={_TC}
                valueIn={item.values.bat}
                hasIn={item.has.bat}
                deactivated="0"
                inputProps={{
                    min: "0",
                    max: "100",
                    step: "1",
                    "data-default": "10",
                }}
            />
        </>
    );
};
export default FormMQConfigAlerts;
